import { Navigate, useParams } from "react-router-dom";
import { useLocale } from "../../intl";
import { runtimeVehicleDetailPath } from "../../clientViewRuntime/utils/routes";

/**
 * Legacy SEO entry: /carros/:vehicleListingId → localized client-view detail.
 */
export default function PublicVehicleDetailPage() {
  const { vehicleListingId } = useParams();
  const { locale } = useLocale();

  if (!vehicleListingId) {
    return <Navigate to={runtimeVehicleDetailPath("automap", "", locale)} replace />;
  }

  return (
    <Navigate
      to={runtimeVehicleDetailPath("automap", vehicleListingId, locale)}
      replace
    />
  );
}
